<div class="run-column" [style.border-top-color]="color">
	<div class="run-header">
		<div class="run-title">
			<mat-icon [style.color]="color">local_shipping</mat-icon>
			<span class="name">Tournée {{ run.seq }}</span>
			<mat-checkbox class="all-workers" [checked]="showAllWorkers" (change)="showAllWorkers = $event.checked"
				title="Par défaut seuls les livreurs sont proposés ; cochez pour ajouter exceptionnellement un autre utilisateur">
				<span class="cb-2l">tout le<br>monde</span>
			</mat-checkbox>
			<mat-button-toggle-group class="slot-toggle" [value]="run.slot" hideSingleSelectionIndicator
				aria-label="Créneau de la tournée">
				<mat-button-toggle [value]="1" (click)="onSlotToggle(1)">Matin</mat-button-toggle>
				<mat-button-toggle [value]="2" (click)="onSlotToggle(2)">Après-midi</mat-button-toggle>
			</mat-button-toggle-group>
			<!-- Toujours rendue, éteinte à vide : sa place est réservée, s'allumer ne décale pas le toggle. -->
			<span class="dirty-chip" [class.on]="dirty" title="Modifications non enregistrées">●</span>
		</div>
		<div class="depot-row">
			<mat-form-field appearance="outline" subscriptSizing="dynamic" class="depot-field">
				<mat-label>Départ (dépôt)</mat-label>
				<mat-select [value]="depotStore" (selectionChange)="depotChange.emit($event.value)">
					@for (s of stores; track s.id) {
						<mat-option [value]="s.id">{{ s.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline" subscriptSizing="dynamic" class="depot-field">
				<mat-label>Heure de départ</mat-label>
				<mat-select [value]="startSlot" (selectionChange)="startSlotChange.emit($event.value)">
					<mat-option [value]="null">—</mat-option>
					@for (s of hourSlots; track s.id) {
						<mat-option [value]="s.id">{{ s.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
		<form [formGroup]="formGroup" class="run-form">
			<mat-form-field appearance="outline" subscriptSizing="dynamic">
				<mat-label>Camion</mat-label>
				<mat-select formControlName="vehicle">
					<mat-option [value]="null">—</mat-option>
					@for (v of vehicles; track v.id) {
						<mat-option [value]="v.id">{{ v.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline" subscriptSizing="dynamic">
				<mat-label>Livreurs</mat-label>
				<mat-select formControlName="workers" multiple>
					@for (u of workerOptions; track u.id) {
						<mat-option [value]="u.id">{{ userLabel(u) }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</form>
	</div>

	<div class="run-list" cdkDropList [cdkDropListData]="deliveries" (cdkDropListDropped)="onDrop($event)">
		@for (d of deliveries; track d.id; let i = $index) {
			<div class="drag-item" cdkDrag [cdkDragData]="d" [cdkDragDisabled]="!!d.realdatdel">
				@if (route) {
					@let av = arrivalView(i);
					<div class="leg-time" [class.unknown]="!route.pending && route.legs[i] == null"
						title="Temps de trajet depuis le point précédent · heure d'arrivée (Géoplateforme IGN)">
						<mat-icon>south</mat-icon><mat-icon>directions_car</mat-icon>
						<span class="leg-dur" [class.struck]="av.state === 'locked'"
							[title]="av.state === 'locked' ? 'Heure fixée : ce temps de trajet ne compte plus' : ''">{{ legLabel(i) }}</span>
						@if (av.implied; as im) {
							<span class="leg-implied" [class.negative]="im.negative" [title]="im.title">{{ im.label }}</span>
						}
						<span class="leg-arrival" [class.fixed]="av.state === 'locked'" [class.committed]="av.state === 'committed'"
							(mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
							@switch (av.state) {
								@case ('live') { <span class="approx" title="Heure estimée">≈</span> }
								@case ('locked') { <mat-icon class="state-icon" inline title="Heure fixée à la main">push_pin</mat-icon> }
								@case ('committed') { <mat-icon class="state-icon" inline title="Heure enregistrée, non recalculée">history</mat-icon> }
							}
							<input type="time" class="arrival-input" [value]="av.hhmm" [disabled]="!!d.realdatdel"
								[title]="av.title" (change)="onArrivalInput(i, $any($event.target).value)">
							@if (av.dayOffset > 0) { <span class="next-day" title="Arrivée le lendemain">J+{{ av.dayOffset }}</span> }
							@if (av.state === 'locked' && !d.realdatdel) {
								<button type="button" class="unpin" title="Heure fixée — revenir au calcul automatique"
									(click)="arrivalClear.emit(i)"><mat-icon inline>close</mat-icon></button>
							}
							@if (av.issues.length) {
								<mat-icon class="issue-icon" inline [title]="av.issues.join('\n')">warning</mat-icon>
							}
						</span>
					</div>
				}
				<app-delivery-card [delivery]="d" [slots]="slots" [ops]="ops" [seq]="i + 1" [color]="color" [highlight]="d.id === highlightBl"
					[editDuration]="!d.realdatdel"
					(durationChange)="durationChange.emit()"></app-delivery-card>
			</div>
		}
		@if (!deliveries.length) {
			<div class="empty-hint">Glissez des livraisons ici</div>
		}
	</div>

	<div class="run-actions">
		<button mat-icon-button color="warn" title="Supprimer la tournée" [disabled]="saving" (click)="remove.emit()">
			<mat-icon>delete</mat-icon>
		</button>
		<!-- Le serveur imprime l'ordre ENREGISTRÉ : éteint tant que l'écran diffère de la base ; disabledInteractive garde l'infobulle qui dit pourquoi. -->
		<button mat-icon-button class="print" [disabled]="!canPrint" disabledInteractive (click)="onPrint()"
			[title]="!run.id || dirty ? 'Validez la tournée pour imprimer ses BL dans cet ordre' : 'Imprimer les BL de la tournée, dans l’ordre de passage'">
			<mat-icon>print</mat-icon>
		</button>
		<span class="count">{{ deliveries.length }} livraison(s)</span>
		@if (route) {
			<span class="route-total"
				[title]="route.missing ? route.missing + ' point(s) sans coordonnées GPS, exclus du calcul' : 'Temps de trajet total de la tournée (Géoplateforme IGN)'">
				<mat-icon>directions_car</mat-icon>{{ totalLabel }}
				@if (route.missing) { <span class="route-warn">⚠{{ route.missing }}</span> }
			</span>
		}
		<button mat-flat-button color="primary" (click)="save.emit()" [disabled]="!dirty || saving">
			<mat-icon>check</mat-icon>&nbsp;{{ saving ? 'Enregistrement…' : 'Valider' }}
		</button>
	</div>
</div>
